/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3VIcon20Regular = forwardRef('UiMenuDots3VIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.56 3.76a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0Z" }),
        React.createElement("path", { d: "M11.56 10a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0Z" }),
        React.createElement("path", { d: "M10 17.8a1.56 1.56 0 1 0 0-3.12 1.56 1.56 0 0 0 0 3.12Z" })));
});
